<template>
    <vue-highcharts :options="chart_options_activity" ref="child"/>
</template>

<script>
    import {Chart} from 'highcharts-vue';
    import Highcharts from "highcharts";
    import HighchartsNoData from 'highcharts/modules/no-data-to-display';
    import i18n from "@/i18n";

    HighchartsNoData(Highcharts);

    Highcharts.setOptions({
        lang: {
            noData: i18n.t('AppVehiclePieChart.Sem dados disponíveis'),
        }
    });

export default {
    created() {
        this.setupChart()
    },
    data() {
        return {
            chart_options_activity: null,
        }
    },
    props: {
        chart_data: {
            type: Array,
            required: true
        }
    },
    methods: {
        setupChart() {
            this.chart_options_activity = {
                chart: {
                    height: 400,
                    style: {
                        fontFamily: 'robotoregular'
                    },
                    type: 'pie'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: i18n.t('AppVehiclePieChart.Último Contato'),
                },
                tooltip: {
                    outside: true,
                    useHTML: true,
                    formatter: function () {
                        return this.point.name + ": " + this.point.y;
                    }
                },
                exporting: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            distance: "-10%",
                            filter: {
                                property: 'y',
                                operator: '>',
                                value: 0
                            },
                            formatter: function () {
                                return this.point.y;
                            }
                        },
                        showInLegend: true,
                    }
                },
                series: [{
                    colorByPoint: true,
                    data: this.chart_data,
                }],
            };
        }
    },
    watch: {
        chart_data: function() {
            this.setupChart()
        }
    },
    components: {
        VueHighcharts: Chart
    },
}
</script>

<style scoped type="scss">

</style>
